module.exports = __webpack_public_path__ + "img/product-14.75543b2e.jpg";